export enum TransactionType {
  CHARGE = 'CHARGE',
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL'
}

export enum TransactionState {
  CANCELED = 'CANCELED',
  CLEARED = 'CLEARED',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  PROCESSING = 'PROCESSING',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED'
}

export enum TransactionStateMapped {
  Complete = 'Complete',
  Failed = 'Failed',
  Processing = 'Processing'
}

type Conversion = {
  creditedAmount?: string
  creditedCurrency?: string
  debitedAmount?: string
  debitedCurrency?: string
  exchangeRate: {
    symbol: string
    value: number
  }
}

type ExtraAttributes = {
  address: string
  authorisationUrl?: string
  beneficiary?: {
    accountRef?: string
  }
  confirmations: number
  conversionAttributes: Conversion
  entity?: string
  hmac: string
  media?: { source: string; type: string }[]
  qrcodeUrl?: string
  status?: string
  txHash: string
}

export type Transaction = {
  amount: { symbol: string; value: string }
  amountMinor: string
  extraAttributes?: ExtraAttributes
  feeMinor: string
  id: string
  insertedAt: string
  state: TransactionState | TransactionStateMapped
  txHash?: string
  type: TransactionType
}

export type TransactionsResponse = {
  items: Transaction[]
  next: string | null
  prev: string | null
}
